import React, {useRef, useState} from "react";
import {Link, useHistory, useLocation} from 'react-router-dom';
import PageContainer from 'publish/layout/PageContainer';
import LayoutAside from "../../../layout/LayoutAside";
import Breadcrumb from 'layouts/main/Breadcrumb';
import UIInput from 'components/input/input';
import Button from 'components/buttons/';
import UIDatePicker from "components/datepicker";
import CommonUtil from "../../../../utils/CommonUtil";
import StringUtil from "../../../../utils/StringUtil";
import codeDataStore from "../../../../common/codedata/store/CodeDataStore";
import UISelect from "../../../../components/selectbox/UISelect";
import UIUtils from "../../../../utils/UIUtils";
import UIUtil from "../../../../utils/UIUtils";
//import UIInput from 'components/input/input';
function ContentsContainer() {
	const [yearList, setYearList] = React.useState<any[]>([{value : new Date().getFullYear()+'', nm : new Date().getFullYear()+'년'}]);
	const [year,setYear] = useState(new Date().getFullYear()+'');
	const [bizCd,setBizCd] = useState('');

	const [totalRowCnt,setTotalRowCnt] = useState(0);
	const [showRowCnt,setShowRowCnt] = useState(5); //기본 row count
	const [dateNum,setDateNum] = useState(0); //날짜 기본값

	const [mode, setMode] = useState('init');

	let sheetCols = useRef<any>([]);

	//초기 데이터 설정
	let totalCnt:number = 0;
	let rowCnt:number = 5;
	let defaultRowCnt = 5;

	//====== 그리드 공통 부 START
	var ib = ib||{};
	ib = {
		//시트 초기화 구문
		'init':{
			"Cfg": {
				"SearchMode": 1,
				"PageLength": defaultRowCnt*3,
				"AutoRowHeight": 1,
				"InfoRowConfig": "0",
				"Alternate":"0",
				"HeaderMerge": 3,
				"DataMerge": 1,
				"PrevColumnMerge": 3,
				"Height": "auto"

			},
			Def:{
				Row:{
					//AlternateColor: "FFFF00" // 하이라이트 색상을 노란색으로 설정
				}
			},
			//틀고정 좌측 컬럼 설정
			"LeftCols": [
				//{"Header": "No","Name": "RN","Width": "90"}
			],

			"Cols": []

		},
		//시트 이벤트
		'event':{
			onRenderFirstFinish:function (evtParam) {
				//초기 데이터 로딩
				doSearch(mode);
			},
			//시트 더블클릭시 이벤트 처리
			onAfterClick:function(evtParam){
				if(evtParam.kind != "Header"){

				}



			},

			onMouseOver:function(evtParam){
				var sheet = evtParam.sheet;
				if (evtParam.row && evtParam.col && evtParam.orow && evtParam.ocol) {

					//console.log("이전 셀 값은 "+ sheet.getValue({row:evtParam.orow, col:evtParam.ocol}));
					//console.log("현재 셀 값은 "+ sheet.getValue({row:evtParam.row, col:evtParam.col}));
					//특정행의 글자를 붉은색으로 지정합니다..
					/*
					var row = evtParam.row;
					row["TextColor"] = "#297BF2";
					sheet.refreshRow(row);

					var oldrow = evtParam.orow;
					oldrow["TextColor"] = "#000000";
					sheet.refreshRow(oldrow);
					*/
				}
			},

			onBeforeDataLoad:function (evtParam) {
				// 조회 후 로딩 전 발생 이벤트
				var d = evtParam.data;
				var _data;

				// 서버에서 가져온 데이터를 "데이터" 텝에 넣어준다.
				if (d.length > 20) { // 최대 20개 행만 텝에 넣어 주자(많아지면 화면이 엄청 느려질 수 있음)
					_data = JSON.stringify(d.slice(0, defaultRowCnt), null, 2);
					_data += _data.substring(0, _data.length - 1) + '...\n]';
				} else {
					_data = JSON.stringify(d, null, 2);
				}

			},
			onAfterGotoPage:function (evtParam) {

				var sheet = evtParam.sheet;
				var page = sheet.getPageIndex(sheet.getFocusedPage()) + 1;
				//@ts-ignore
				if (currentPage != -1 && currentPage != page) {
					makePageIndex(page);
				}

			}
		},
		//시트객체 생성
		'create':function () {
			let options = this.init;

			sheetCols.current = [
				{"Header": "사업","Type": "Text","Name": "GROUP_BIZ_NM","RelWidth": 1.5,"Align": "Center","CanEdit": "0"},
				{"Header": "기부내용","Type": "Text","Name": "GROUP_CODE_NM","RelWidth": 2,"Align": "Center","CanEdit": "0"},
				{"Header": "구분","Type": "Text","Name": "GUBUN","RelWidth": 2,"Align": "Center","CanEdit": "0"},
				{"Header": "합계","Type": "Int","Name": "TOTAL","RelWidth": 2,"Align": "Right","CanEdit": "0"},
			];


			let endYear = year;
			let startYear = new Date().getFullYear();
			for(let j = startYear; j >= Number(endYear); j--){
				sheetCols.current.push({"Header": j,"Type": "Int","Name": j,"RelWidth": 2,"Align": "Right","CanEdit": "0"})
			}


			options.Cols = sheetCols.current;


			//@ts-ignore
			options.Events = this.event;
			//@ts-ignore
			IBSheet.create({
				id: 'sheet', // 생성할 시트의 id
				el: 'sheetDiv', // 시트를 생성할 Dom 객체 및 id
				options: options, // 생성될 시트의 속성
				data: this.data // 생성될 시트의 정적데이터
			});
			// global 변수 선언
			//@ts-ignore
			window.currentPage = -1;
		},
		//엑셀 다운로드
		'exportData':function () {

		},
		//조회 데이터
		'data':[]
	}

	//====== 그리드 공통 부  END

	// init
	React.useEffect(() => {

		//ib시트 생성
		ib.create();

		initCall();


		//필요한 공통코드 로딩.
		codeDataStore.read("cfms.portalBizCdList");


		return () => {
			// @ts-ignore
			IBSheet.disposeAll(true);
		}
	},[])

	function initCall(){
		let start = new Date().getFullYear() - 10;
		let end = new Date().getFullYear();
		let newYearList = [];
		for(let i = start; i <= end; i++){
			// @ts-ignore
			newYearList.push({value : i+'', nm : i+'년'})
		}
		setYearList(newYearList);
	}


	//페이지 건수별로 보기
	const handleSelect = (e) => {
		if(e.target.name === 'showRowCnt'){
			setShowRowCnt(e.target.value);
			// @ts-ignore
			IBSheet.disposeAll(true);
			ib.init.Cfg.PageLength = e.target.value;
			rowCnt = e.target.value;
			ib.create();

		}else if(e.target.name === 'year'){
			setYear(e.target.value);
		}


	};

	function destroySheet(){
		setMode('search')
		// @ts-ignore
		IBSheet.sheet.dispose();
		//ib시트 생성
		ib.create();
	}


	//====== 그리드 데이터 가지고 오기  START
	async function doSearch(sAction:string) {


		let param = {
				"YEAR": year,
				"BIZ_CD":bizCd
		};

		//파라미터 전송
		const response:any = await CommonUtil.execute({
			url:'usr_2113',
			data: param
		})


		//전체데이터
		let result = response.REC;




		// @ts-ignore
		if(typeof result == 'undefined'){
			alert('data is not loaded!!!')
			return;
		}

        if(result.length != 0){

		}


		// @ts-ignore
		let dupList = [...new Map(result.map((a) => [a.BIZ_NM, a])).values()];


		//전체ROW개수
		totalCnt = dupList.length*3;
		setTotalRowCnt(dupList.length*3);


		let endYear = year;
		let startYear = new Date().getFullYear();
		let newList = [];
		for(let i = 0; i < dupList.length; i++){
			let info = dupList[i];
			// @ts-ignore
			newList.push({
				'GROUP_BIZ_NM' : info.BIZ_NM,
				'GROUP_CODE_NM' : '금전',
				'GUBUN' : '출연',
				'TOTAL' : 0
			});
			// @ts-ignore
			newList.push({
				'GROUP_BIZ_NM' : info.BIZ_NM,
				'GROUP_CODE_NM' : '금전',
				'GUBUN' : '지원',
				'TOTAL' : 0
			});
			// @ts-ignore
			newList.push({
				'GROUP_BIZ_NM' : info.BIZ_NM,
				'GROUP_CODE_NM' : '금전',
				'GUBUN' : '잔액',
				'TOTAL' : 0
			});
			for(let j = startYear; j >= Number(endYear); j--){
				// @ts-ignore
				newList[i*3][j+''] = 0
				// @ts-ignore
				newList[i*3+1][j+''] = 0
				// @ts-ignore
				newList[i*3+2][j+''] = 0
			}
		}

		for(let i = 0; i < result.length; i++){
			// @ts-ignore
			let info = newList.filter(a => a.GROUP_BIZ_NM == result[i].BIZ_NM)
			if(info.length != 0){
				// @ts-ignore
				info.filter(a => a.GUBUN == '출연')[0][result[i].YEAR] = Number(result[i].IN_DON_AMT);
				// @ts-ignore
				info.filter(a => a.GUBUN == '출연')[0]['TOTAL'] = Number(info.filter(a => a.GUBUN == '출연')[0]['TOTAL']) + Number(result[i].IN_DON_AMT);

				// @ts-ignore
				info.filter(a => a.GUBUN == '지원')[0][result[i].YEAR] = Number(result[i].OUT_DON_AMT);
				// @ts-ignore
				info.filter(a => a.GUBUN == '지원')[0]['TOTAL'] = Number(info.filter(a => a.GUBUN == '지원')[0]['TOTAL']) + Number(result[i].OUT_DON_AMT);

				// @ts-ignore
				info.filter(a => a.GUBUN == '잔액')[0][result[i].YEAR] = Number(result[i].REMAIN_AMT);
				// @ts-ignore
				info.filter(a => a.GUBUN == '잔액')[0]['TOTAL'] = Number(info.filter(a => a.GUBUN == '잔액')[0]['TOTAL']) + Number(result[i].REMAIN_AMT);
			}
		}


		//데이터 처리
		ib.data = newList;


		// @ts-ignore
		sheet.loadSearchData(newList);  //data 로딩 처리
		// @ts-ignore
		sheet.InfoRow.Visible = 0; // 페이지네비게이션 표시 안함
		// @ts-ignore
		makePageIndex(sheet.getPageIndex( sheet.getFocusedPage()) + 1); // 페이지 초기화

	}

	//====== 그리드 데이터 가지고 오기  END

	//====== 그리드 페이징 처리
	// @ts-ignore
	const makePageIndex = function (tp:number) {
		try {
			if (tp == null) {
				//@ts-ignore
				currentPage = -1;
				return;
			}

			// @ts-ignore
			if (document.getElementById('pageNavi').firstChild) {
				// @ts-ignore
				document.getElementById('pageNavi').removeChild(document.getElementById('pageNavi').firstChild);
			}


			// @ts-ignore
			currentPage = tp;
			// @ts-ignore
			let sr = totalCnt/3 // 전체 조회 건수
			// @ts-ignore
			let page = rowCnt*3; // 페이지당 레코드 수
			let thispage = tp; // 현재 페이지
			let pagecnt = 5; // 한번에 표시할 페이지 개수
			let lastpage = Math.ceil(sr / page); // 마지막 페이지 인덱스
			let li, tt, a;
			let ul = document.createElement('DIV');
			// @ts-ignore
			ul.style.textAlign = 'center';

			let k = 1;

			if (thispage !== 1) {
				let ul_sub = document.createElement('DIV');
				ul_sub.className ="group";
				li = document.createElement('Button');
				li.className = 'item first';
				a = document.createElement('a');
				a.style.cursor = 'pointer';
				tt = document.createTextNode('<<');
				addEventHandler(li, 'click', pageMove, 1);
				a.appendChild(tt);
				li.appendChild(a);
				ul_sub.appendChild(li)
				ul.appendChild(ul_sub);

				li = document.createElement('Button');
				li.className = 'item prev';
				a = document.createElement('a');
				a.style.cursor = 'pointer';
				addEventHandler(li, 'click', pageMove, tp - 1);
				tt = document.createTextNode('<');
				a.appendChild(tt);
				li.appendChild(a);
				ul_sub.appendChild(li)
				ul.appendChild(ul_sub);
			}

			sr = (Math.ceil(tp / pagecnt) * pagecnt) - (pagecnt - 1);
			let ul_sub2 = document.createElement('DIV');
			ul_sub2.className ="group";
			for (let i = sr; i < (sr + pagecnt); i++) {
				if (i <= lastpage) {
					li = document.createElement('Button');
					li.className ="item";
					a = document.createElement('a');
					a.style.cursor = 'pointer';
					tt = document.createTextNode(String(i));
					addEventHandler(li, 'click', pageMove, i);
					if (i === tp) {
						li.className ="item active";
					}
					a.appendChild(tt);
					li.appendChild(a);
					ul_sub2.appendChild(li);
					ul.appendChild(ul_sub2);
				}
			}

			if (thispage < lastpage) {
				let ul_sub3 = document.createElement('DIV');
				ul_sub3.className ="group";
				a = document.createElement('a');
				a.style.cursor = 'pointer';
				li = document.createElement('Button');
				li.className = 'item next';
				tt = document.createTextNode('>');
				addEventHandler(li, 'click', pageMove, tp + 1);
				a.appendChild(tt);
				li.appendChild(a);
				ul_sub3.appendChild(li);
				ul.appendChild(ul_sub3);

				li = document.createElement('Button');
				li.className = 'item last';
				tt = document.createTextNode('>>');
				a = document.createElement('a');
				a.style.cursor = 'pointer';
				addEventHandler(li, 'click', pageMove, lastpage);
				a.appendChild(tt);
				li.appendChild(a);
				ul_sub3.appendChild(li);
				ul.appendChild(ul_sub3);
			}

			ul.className = 'pg';
			// @ts-ignore
			document.getElementById('pageNavi').appendChild(ul);
		} catch (ex) {
			// @ts-ignore
			alert(ex.message);
		}
	}

	//페이지 이동
	// @ts-ignore
	const pageMove = function (cPage:number) {
		// @ts-ignore
		sheet.goToPageByIndex(cPage);

	}

	//페이지 이동 이벤트 핸들러
	// @ts-ignore
	const addEventHandler = function (obj, evtName, func, param) {
		if (obj.addEventListener) { // all browsers except IE before version 9
			obj.addEventListener(evtName, function () { func(param); }, false);
		} else if (obj.attachEvent) { // IE before version 9
			obj.attachEvent('on' + evtName, function () { func(param); });
		}
	}

	//인풋 엔터체크
	const activeEnter = (e) => {
		if(e.key === "Enter") {
			doSearch('search');
		}
	}





	return (
		<PageContainer>
			<LayoutAside />
			<div className='fww-con'>
				{/*<Breadcrumb gnbIdx={1} lnbIdx={4}/>*/}
				<main className="fww-main">
					<h1 className="tx tx-hd2">출연ㆍ지원 현황</h1>
					<form className="sf sf-fund" name="" action="" method="">
						<div className="inner">
							<div className="sf-item">
								<p className="sf-key">기간</p>
								<div className="sf-value">
									<div className="hz-root hz-gap5">
										<div className="sl sl-md w120">
											<select name="year" id="year" value={year} onChange={(handleSelect)}>
												{yearList.map((year, idx) => (
													<option value={year.value}>{year.nm}</option>
												))}
											</select>
										</div>
									</div>
								</div>
							</div>
							<div className="sf-item">
								<p className="sf-key">출연사업</p>
								<div className="sf-value">
									<div className="sl sl-md">
										<UISelect
											codeData={codeDataStore.get("cfms.portalBizCdList")}
											value={bizCd}
											valueChanged={(value) => setBizCd(String(value))}
											firstName={"sel"}
										/>
									</div>
								</div>
							</div>
						</div>
					</form>
					<div className="hz-root hz-center mb25">
						{/*<Button color="pri" size="md" onClick={()=> doSearch('search')}>조회</Button>*/}
						<Button color="pri" size="md" onClick={()=> destroySheet()}>조회</Button>
					</div>
					<div className="tb-top">
						<div className="hz-root">
							<p className="tx fc-black">총 <em className="fw500">{totalRowCnt/3}</em>건</p>
						</div>
						<div className="hz-root hz-gap5">
							<p className="mr15">단위(원)</p>
							<Button color="gray-o" size="sm">다운로드</Button>
						</div>
					</div>
					<div id='sheetDiv' >[D] IBSHEET 영역</div>
					<div id="pageNavi" className="pg"></div>
				</main>
			</div>
		</PageContainer>
	);
}
export default ContentsContainer;